import { useNavigate, useParams } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import {
  TCreateFormConfigPaylod,
  useAlreadyCreatedFormConfigs,
  useGetFormConfig,
  usePatchFormConfig,
} from "../../../hooks/form-step-config.hooks";
import { useServiceTypes } from "../../../hooks/forms.hooks";
import StepConfigForm from "./Form";

export function EditStepConfigurations() {
  const { id = "" } = useParams();
  const { isFetching: isFetching1, isError: isError1 } =
    useAlreadyCreatedFormConfigs();
  const { isFetching: isFetching2, isError: isError2 } = useServiceTypes();
  const {
    data,
    isFetching: isFetching3,
    isError: isError3,
  } = useGetFormConfig(+id);
  const { mutate } = usePatchFormConfig();
  const navigate = useNavigate();

  const onSubmit = (payload: TCreateFormConfigPaylod) => {
    mutate(
      { ...payload, id: +id },
      { onSuccess: () => navigate("/step-configurations", { replace: true }) }
    );
  };

  const isFetching = isFetching1 || isFetching2 || isFetching3;

  const isError = isError1 || isError2 || isError3;

  let toRender = null;
  if (isFetching || isError || !data?.id) {
    toRender = (
      <div className="flex justify-center items-center p-8">
        {isError || !data?.id ? (
          <p>Something went wrong while fetching info!</p>
        ) : (
          <SpinnerCircular />
        )}
      </div>
    );
  } else {
    toRender = (
      <StepConfigForm
        ctx="edit"
        onSubmit={onSubmit}
        defaultValues={{
          active: data?.active || false,
          serviceName: data?.serviceName || "",
          selectedForms: data?.steps || [],
        }}
      />
    );
  }

  return <div>{toRender}</div>;
}
